import { t } from '../../../i18n.es.js';
import React from 'react';
import { styled, Currency } from '@teko/ui';

const Percent = styled.span`
  margin-left: 4px;
`;
const StyledCurrency = styled(Currency)`
  margin: 0 4px;
  color: #ed2101;
  font-weight: 500;
`;
const OrderValueMin = styled.span`
  margin-left: 4px;
`;
const OrderValueMax = styled(Percent)``;
const PromotionInfo = ({
  money,
  condition
}) => {
  if (!money)
    return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, money.discountType === "percent" ? /* @__PURE__ */ React.createElement(Percent, null, money.percent, t("% t\u1ED1i \u0111a"), /* @__PURE__ */ React.createElement(StyledCurrency, {
    value: money.maxDiscount || 0
  })) : /* @__PURE__ */ React.createElement(StyledCurrency, {
    value: money.money || 0
  }), condition && /* @__PURE__ */ React.createElement(React.Fragment, null, condition.orderValueMin && /* @__PURE__ */ React.createElement(OrderValueMin, null, t("cho \u0111\u01A1n h\xE0ng t\u1EEB"), /* @__PURE__ */ React.createElement(Currency, {
    value: condition.orderValueMin
  })), condition.orderValueMax && /* @__PURE__ */ React.createElement(OrderValueMax, null, t("\u0111\u1EBFn"), /* @__PURE__ */ React.createElement(Currency, {
    value: condition.orderValueMax
  }))));
};

export { PromotionInfo };
